document.addEventListener('DOMContentLoaded', function () {
  const productData = JSON.parse(document.getElementById('productData').textContent);
  const priceEl = document.getElementById('currentPrice');
  const compareEl = document.getElementById('comparePrice');
  const discountEl = document.getElementById('discountBadge');
  const hiddenInput = document.querySelector('input[name="id"]');
  const variantButtons = document.querySelectorAll('.variant-btn');



  variantButtons.forEach(button => {
    button.addEventListener('click', function () {
      variantButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
    });
  });

  const slider = document.getElementById('mediaSlider');
  const slides = document.querySelectorAll('.slide');
  const thumbnails = document.querySelectorAll('.thumbnail');
  const mainMedia = document.getElementById('mainMedia');

  let currentIndex = 0;

  function goToSlide(index) {
    if (window.innerWidth <= 768) return;
    slider.style.transform = `translateX(-${index * 100}%)`;
    currentIndex = index;

    thumbnails.forEach(t => t.classList.remove('active'));
    if (thumbnails[index]) {
      thumbnails[index].classList.add('active');
    }
  }

  if (thumbnails.length) {
    thumbnails[0].classList.add('active');
  }

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', function () {
      updateMainMedia(index);
    });
  });


  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');

  let desktopIndex = 0;

  // Build media list from thumbnails
  const mediaItems = Array.from(thumbnails).map(t => ({
    type: t.getAttribute('data-type'),
    src: t.getAttribute('data-src')
  }));

  function updateMainMedia(index) {
    if (!mediaItems[index]) return;

    const item = mediaItems[index];

    thumbnails.forEach(t => t.classList.remove('active'));
    if (thumbnails[index]) thumbnails[index].classList.add('active');

    if (item.type === 'image') {
      mainMedia.innerHTML = `<img src="${item.src}" alt="Product image">`;
    } else if (item.type === 'video') {
      mainMedia.innerHTML = `
        <video controls autoplay style="width:100%; border-radius:16px;">
          <source src="${item.src}" type="video/mp4">
        </video>
      `;
    }

    desktopIndex = index;
  }

  // NEXT
  nextBtn?.addEventListener('click', () => {
    let nextIndex = desktopIndex + 1;
    if (nextIndex >= mediaItems.length) nextIndex = 0;
    updateMainMedia(nextIndex);
  });

  // PREV
  prevBtn?.addEventListener('click', () => {
    let prevIndex = desktopIndex - 1;
    if (prevIndex < 0) prevIndex = mediaItems.length - 1;
    updateMainMedia(prevIndex);
  });

  let startX = 0;

  slider.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
  });

  slider.addEventListener('touchend', e => {
    let endX = e.changedTouches[0].clientX;
    let diff = startX - endX;

    if (diff > 50 && currentIndex < slides.length - 1) {
      goToSlide(currentIndex + 1);
    } else if (diff < -50 && currentIndex > 0) {
      goToSlide(currentIndex - 1);
    }
  });
  goToSlide(0);

  function formatMoney(cents) {
    return (cents / 100).toFixed(2);
  }
  function updateUI(variant) {
    hiddenInput.value = variant.id;
    if (priceEl) {
      priceEl.innerText = `$${formatMoney(variant.price)}`;
    }

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (compareEl) {
        compareEl.style.display = 'inline';
      }

      if (discountEl) {
        discountEl.style.display = 'inline';
      }
      // compareEl.style.display = 'inline';
      // discountEl.style.display = 'inline';

      compareEl.innerText = ` ${formatMoney(variant.compare_at_price)}`;

      let discount = Math.round(
        ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
      );

      discountEl.innerText = `${discount}% OFF`;
    } else {
      if (compareEl) {
        compareEl.style.display = 'none';
      }

      if (discountEl) {
        discountEl.style.display = 'none';
      }
      // compareEl.style.display = 'none';
      // discountEl.style.display = 'none';
    }
    if (variant.featured_image) {
      mainMedia.innerHTML = `<img src="${variant.featured_image.src}" />`;
    }
  }

  // variantButtons.forEach(button => {
  //   button.addEventListener('click', function () {

  //     variantButtons.forEach(btn => btn.classList.remove('active'));
  //     this.classList.add('active');

  //     const variantId = this.dataset.variantId;

  //     const selectedVariant = productData.variants.find(
  //       v => v.id == variantId
  //     );

  //     if (selectedVariant) {
  //       updateUI(selectedVariant);
  //     }
  //   });
  // });

  // Open Modal
  document.querySelectorAll('.nutrition-modal-button').forEach(button => {
    button.addEventListener('click', () => {
      const id = button.id.replace('view-nutrition-btn', 'nutrition-modal');
      const dialog = document.getElementById(id);

      if (dialog) {
        dialog.showModal(); // open dialog
      }
    });
  });

  // close modal
  document.querySelectorAll('.nutrition-modal__close').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      const dialog = closeBtn.closest('dialog');

      if (dialog) {
        dialog.classList.add('closing');

        setTimeout(() => {
          dialog.close();
          dialog.classList.remove('closing');
        }, 300); // match your CSS animation duration
      }
    });
  });

  // close when clicking backdrop
  document.querySelectorAll('.nutrition-modal').forEach(dialog => {
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dialog.classList.add('closing');

        setTimeout(() => {
          dialog.close();
          dialog.classList.remove('closing');
        }, 300);
      }
    });
  });

  document.querySelectorAll('.accordion-title').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.accordion-item');
      const content = item.querySelector('.accordion-content');
      const isOpen = item.classList.contains('active');

      document.querySelectorAll('.accordion-item').forEach(i => {
        if (i !== item) {
          i.classList.remove('active');
          const c = i.querySelector('.accordion-content');
          c.style.height = '0px';
        }
      });

      if (isOpen) {
        content.style.height = content.scrollHeight + 'px'; 
        requestAnimationFrame(() => {
          content.style.height = '0px';
        });
        item.classList.remove('active');
      } else {
        item.classList.add('active');
        content.style.height = '0px';
        requestAnimationFrame(() => {
          content.style.height = content.scrollHeight + 'px';
        });
      }
    });
  });
});
